<template>
    <div>
        <page-title>{{ title }}</page-title>
        <user-route-tabs class="mb-4" :user-id="userId"></user-route-tabs>
        <company-balances-table :user-id="userId"></company-balances-table>
    </div>
</template>

<script>
import SelectApiClienType from '@/api/SelectApiClientType'
import TitleMixinGenerator from '@/components/mixins/page-title/TitleMixinGenerator'
import UserRouteTabs from '@/components/pages/users/RouteTabs'
import CompanyBalancesTable from '@/components/pages/companyBalance/Table'

export default {
    components: { UserRouteTabs, CompanyBalancesTable },
    mixins: [TitleMixinGenerator(SelectApiClienType.USER, 'userId')],
    props: {
        userId: {
            type: [String, Number],
            default: null,
        },
    },
}
</script>
